import { useLocation, Navigate } from "react-router-dom";
import { ROUTES } from "../../constants";

const { HOME } = ROUTES;

const Restrict = (props) => {
  const { shouldShowNav, isUnsecuredRoute, children } = props;
  const location = useLocation();

  if (shouldShowNav && isUnsecuredRoute) {
    return <Navigate to={HOME} state={{ from: location }} replace={true} />;
  }
  else {
    return children;
  }
};

export default Restrict;
